export default [
    {
      "value": "MALE",
      "comment": "MALE"
    },
    {
      "value": "FEMALE",
      "comment": "FEMALE"
    },
    {
      "value": "OTHER",
      "comment": "OTHER"
    },
    {
      "value": "RATHERNOTSAY",
      "comment": "I'D RATHER NOT SAY"
    },
    {
      "value": "NON_BINARY",
      "comment": "NON BINARY"
    }
  ]